import React from "react";

type Props = {
  value: string | undefined;
  placeholder?: string | undefined
  onChange: (value: string | undefined) => void;
  onContinue: () => void; // hits enter on the field

  inputType?: string,
  min?: number,
  max?: number
}

export const TextSurveyInput = (props: Props) => {
  return <input type={props.inputType || 'text'} className={'SurveyTextInput'}
                min={props.min} max={props.max}
                placeholder={props.placeholder || 'Enter text here'}
                value={props.value}
                onKeyPress={event => {
                  if (event.key == 'Enter') {
                    props.onContinue();
                  }
                }}
                onChange={event => {
                  props.onChange(event.target.value);
                }}
  />
}